import { s } from '@/theme/tokens';
import { Text } from '@/ui';
import { Box, NumberSpinner } from '@/ui/primitives';
import type { ReactElement } from 'react';

const durationPartInputHeight = 32;

const spinnerSx = {
  width: '100%',
  maxWidth: '124px',
} as const;

const fieldSx = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: s('sm'),
  minWidth: 0,
} as const;

type DurationSpinnerFieldProps = {
  label: string;
  value: string;
  min: number;
  max?: number;
  error: boolean;
  onChange: (nextValue: string) => void;
};

export const DurationSpinnerField = ({
  label,
  value,
  min,
  max,
  error,
  onChange,
}: DurationSpinnerFieldProps): ReactElement => (
  <Box sx={fieldSx}>
    <Text
      role="body"
      sx={(theme) => ({
        whiteSpace: 'nowrap',
        fontSize: theme.typography.subtitle1.fontSize,
        lineHeight: theme.typography.subtitle1.lineHeight,
      })}
    >
      {label}
    </Text>
    <NumberSpinner
      value={value}
      min={min}
      max={max}
      step={1}
      size="small"
      inputHeight={durationPartInputHeight}
      onChange={onChange}
      error={error}
      fieldStyle="settings"
      sx={spinnerSx}
    />
  </Box>
);
